import React, {useEffect} from 'react';
import {Alert, Button, Divider, Form, Input, InputNumber, message, Switch} from 'antd';
import UserEmailField from "../Components/UserEmailField";
import JobSchedulingSection from "../Components/JobSchedulingSection";
import {useDispatch, useSelector} from "react-redux";
import {
    getCurrentSpaceStatisticsThunk,
    getCurrentSpaceThunk,
    getSpacesThunk,
    updateSpaceThunk
} from "../Feature/SpacesSlice";
import formatBytes from "../Utils/conversions";
import {useParams} from "react-router-dom";
import {useAdminMode} from "../hooks/useAdminMode";

const defaultFormItemLayout = {
    labelCol: {
        xs: {span: 6}
    },
    wrapperCol: {
        xs: {span: 12}
    }
};


export const SpaceSettings = () => {
    const dispatch = useDispatch();
    const { spaceId } = useParams();
    const { adminMode, toggleAdminMode } = useAdminMode();
    const currentSpace = useSelector((state) => {
        return state.spaces.current
    });
    const currentUser = useSelector((state) => {
        return state.firebase.auth?.currentUser;
    });

    const [form] = Form.useForm();

    // Check if current user is the space owner
    const isOwner = currentSpace?.data?.spaceOwner?.uid === currentUser?.uid;

    useEffect(() => {
        if (!currentSpace.data || currentSpace.data.id !== spaceId) {
            dispatch(getCurrentSpaceThunk(spaceId))
        }
    }, [dispatch, spaceId, currentSpace.data]);

    useEffect(() => {
        form.setFieldsValue(currentSpace.data)
        if (currentSpace.data) {
            dispatch(getCurrentSpaceStatisticsThunk(currentSpace.data.id))
        }
    }, [dispatch, form, currentSpace.data]);

    function handleFinish(values) {
        const payload = {spaceId: spaceId, data: values}
        dispatch(updateSpaceThunk(payload))
            .then(() => dispatch(getSpacesThunk()))
            .then(() => dispatch(getCurrentSpaceThunk()))
            .then(() => message.success("Space was updated."))
    }

    return (
        <>
            <h1>Settings</h1>
            <Divider/>
            {currentSpace.statistics ?
                <Alert message={`You are using ${formatBytes(currentSpace.statistics.size)} / 1GB`} type="success"/>
                : null
            }
            <Divider/>
            <Form form={form} {...defaultFormItemLayout} onFinish={handleFinish}>
                <h4>Space Name</h4>
                <Form.Item
                    name="space_name"
                    rules={[{required: true}]}
                >
                    <Input/>
                </Form.Item>
                <Divider/>

                {isOwner && (
                    <>
                        <h4>Admin Mode</h4>
                        <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px'}}>
                            <span style={{fontSize: '14px'}}>Enable admin features for bulk operations and deleted item visibility</span>
                            <Switch
                                checked={adminMode}
                                onChange={toggleAdminMode}
                            />
                        </div>
                        <Divider/>

                        <h4>Distribution Email</h4>
                        <Form.Item
                            name="distribution_email"
                        >
                            <Input type="email" placeholder="email@example.com"/>
                        </Form.Item>
                        <Divider/>

                        <h4>Noisy Login</h4>
                        <Form.Item
                            name="noisy_login"
                        >
                            <Input placeholder="Login credentials"/>
                        </Form.Item>
                        <Divider/>

                        <h4>Noisy Password</h4>
                        <Form.Item
                            name="noisy_password"
                        >
                            <Input.Password placeholder="Password credentials"/>
                        </Form.Item>
                        <Divider/>

                        <h4>Minimum Number for Booking</h4>
                        <Form.Item
                            name="min_number_for_booking"
                        >
                            <InputNumber min={1} placeholder="Minimum participants required"/>
                        </Form.Item>
                        <Divider/>

                        <JobSchedulingSection spaceId={spaceId} />
                        <Divider/>
                    </>
                )}

                <h4>Space Members</h4>
                <UserEmailField/>
                <Divider/>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </>

    );

}
